export default "__VITE_ASSET__69734e6f__"